import UnsignedInt16 from './Integers/UnsignedInt16';
export default function asUnsignedInt16(value) {
    return new UnsignedInt16(value);
}
